// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module__header___aCEHW","title":"styles-module__title___iiqHQ","closeButton":"styles-module__closeButton___1KY8b","main":"styles-module__main___IULuZ"};